module.exports = __webpack_public_path__ + "static/media/studio 1 main area seating waiting decor.1280x720.4f46eca4.webp";